// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__gIe8+","title":"Aside_title__Ks6kI"};